<template>
  <div class="app-toolbar">
    <div class="start">
      <slot name="start"></slot>
    </div>

    <div class="end">
      <slot name="end"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppToolbar'
}
</script>

<style lang="scss" scoped>
.app-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  .start,
  .end {
    display: flex;
    align-items: center;
  }
}
</style>
